import constant from "../constant";
const initialState = {
  loaded: false,
  loading: false,
  pageLoaded: 0,
  allLoaded: false,
  kbUsed: 0,
  data: []
};


const gallery = (state = initialState, action) => {
  switch (action.type) {
    case constant.ADD_GALLERY_LIST:
      let updateData = {}
      if (action.payload?.pageLoaded) updateData.pageLoaded = action.payload?.pageLoaded;
      if (action.payload?.data) updateData.data = action.payload?.data;
      if (action.payload?.kbUsed) updateData.kbUsed = action.payload?.kbUsed;
      updateData.allLoaded = action.payload?.allLoaded ? action.payload?.allLoaded : state?.allLoaded ? state?.allLoaded : false;
      return { loaded: true, loading: false, ...updateData };
    case constant.ADD_GALLERY:
      let data = state.data;
      let index = data.findIndex(data => data._id == action.payload._id);
      if (index > -1) {
        data[index] = action.payload;
      } else {
        data = [action.payload, ...data];
      }
      return { ...state, data: data };
    default:
      return state;
  }
}



export default gallery;